<template>
    
    <div class="m-t-20">
        <h2 class="has-text-weight-medium is-size-4">Imagenes. </h2>
        
        <div class="columns m-t-5">
            <div class="column">
                <b-field >
                    <b-upload 
                        v-model="dropImages"
                        multiple
                        drag-drop
                        style="width:100%; display: block"
                        v-on:input="updateData({obj:'images', data:encodedImages})">
                        <section class="section" >
                            <div class=" has-text-centered">
                                <p>
                                    <b-icon
                                        icon="upload"
                                        size="is-large">
                                    </b-icon>
                                </p>
                                <p>Solta un archivo aqui arriba, o haz click</p>
                            </div>
                        </section>
                    </b-upload>
                </b-field>
            </div>
            
        </div>

        <div class="columns is-tablet is-multiline m-t-10 m-b-10">
            <div v-for="(x, index) in dropImagesDisplay" 
            :key="x" 
            class="column is-one-fifth has-text-centered over-this">
                <div class="insider">
                    <img :src="x" class="displayImgs">
                    <div class="overlay">
                        <b-button 
                        type="is-danger is-small" 
                        rounded
                        @click="deleteDropImage(index)">
                            <b-icon 
                            class="p-0" 
                            icon="times">
                            </b-icon>
                        </b-button>
                    </div>
                </div>
                <b-field>
                    <b-radio
                    v-model="defaultImg"
                    :native-value="x"
                    @input="imageSetAsDefault(index)">
                        <p>Imagen default</p>
                    </b-radio>
                </b-field>
            </div>
        </div>
    
    </div>

</template>

<script>
import {mapActions} from 'vuex';
export default {
    data(){
        return{
            dropImages:[],
            defaultImg:{},
        }
    },
    computed:{
        dropImagesDisplay(){
            if(this.dropImages.length){
                let arr = []
               
                Array.from(this.dropImages).forEach(file => { 
                    
                    arr.push(
                        window.URL.createObjectURL(file)
                    )
                });
                return arr
            } 
            else {
                return null
            }
        },
        encodedImages(){
            
            if(this.dropImages.length){
                let arr = []
                Array.from(this.dropImages).forEach(file => { 
                    let reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onloadend = () => {
                    arr.push(
                        reader.result
                    )
                    }
                    
                });
                return arr
            } 
            else {
                return null
            }

        }
        
    },
    methods:{
        ...mapActions(['updateData']),
        deleteDropImage(index){
            this.dropImages.splice(index, 1)
            this.updateData({obj:'images', data:this.encodedImages})
        },
        imageSetAsDefault(index){
            var img = this.encodedImages[index]
            this.updateData({obj:'defaultImg', data:img})
        }
    }
}
</script>

<style lang="scss" scoped>

.column{
    margin:0;
    margin-top:2px;
    padding:0;
}

.uploadField{
    width: 100%;
}

.displayImgs{
   
    max-height: 250px;
    border:1px solid #ddd;
    border-radius: 5px;
}



.insider{
    width: 100%;
    max-height: 250px;
    display: block;
    position: relative;
}

.overlay{
    opacity: 0;
    transition: all .5s;
    position: absolute;
    z-index: 15000;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    border-radius: 5px;

    button{
        position:absolute;
        right:5px;
        top:5px;
    }
}
.insider:hover .overlay{
    opacity: 1;
}
.insider:focus .overlay{
    opacity: 1;
}

</style>
